import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { List } from './List';
import { Create } from './Create';
import { Edit } from './Edit';
import { EditChildren } from './EditChildren';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';

export interface HotelAdminRoutingProps extends RouteComponentProps {}

export const HotelAdminRouting = (props: HotelAdminRoutingProps) => {
  const { dynamicParameters } = useDynamicParameters();
  
  return (
    <Switch>
      <Route path={`${props.match.path}/`} component={List} exact />
      {!dynamicParameters.ENABLE_CRM_WORKSPACE_TEMP && <Route path={`${props.match.path}/create`} component={Create} exact />}
      <Route path={`${props.match.path}/:hotelUuid/edit`} component={Edit} />
      <Route path={`${props.match.path}/:hotelUuid/edit-children`} component={EditChildren} />
    </Switch>
  );
};
